import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import { formatPercentage, NoDataAvailable, potentialColors } from '../helpers/helper';

export default function DocumentClicksCard({ documentClicks }) {
  const colorsUsed = Object.keys(documentClicks).map((_doc, index) => {
    return potentialColors[index % potentialColors.length];
  });

  const totalClicks = Object.values(documentClicks).reduce((sum, documentClick) => {
    return sum + documentClick.clicks;
  }, 0);

  const data = {
    datasets: [{
      data: Object.values(documentClicks).map(docs => docs.clicks),
      backgroundColor: colorsUsed
    }],
  };

  const options = {
    height: null,
    width: null,
    legend: {
      display: false
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      cutoutPercentage: 75,
      hover: { mode: null },
      tooltips: { enabled: false }
    }
  };

  return (
    <div className="dashboard-card dashboard-card-full d-flex flex-column">
      <h3 className="d-title">Document Clicks</h3>
      {Object.keys(documentClicks).length > 0 ? (
        <div className="flex-1 d-flex flex-column">
          <div className="d-flex justify-content-center flex-wrap">

            {Object.values(documentClicks).map((documentClick, index) => {
              const clickDecimalPercentage = documentClick.clicks / totalClicks;

              return (
                <div className="mr-2 d-flex align-items-center" key={index}>
                  <span className="legend-color mr-2" style={{ backgroundColor: colorsUsed[index] }}></span>
                  {formatPercentage(clickDecimalPercentage)}% {documentClick.name}
                </div>
              );
            })}
          </div>
          <div className="flex-1">
            <Doughnut data={data} {...options} />
          </div>
        </div>
      ) : (
        <NoDataAvailable/>
      )}
    </div>
  );
}

DocumentClicksCard.propTypes = {
  documentClicks: PropTypes.object.isRequired,
};
